import {useState, useEffect, useRef} from 'react';
import TallOuterContainer from './tall-outer-container';
import StickyInnerContainer from './sticky-inner-container';
import HorizontalTranslateContainer from './horizontal-translate-container';
//import { Parallax, ParallaxLayer } from '@react-spring/parallax';

const calcDynamicHeight = objectWidth => {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    return objectWidth - vw + vh + 150;
  };
  
  const handleDynamicHeight = (ref, setDynamicHeight) => {
    const objectWidth = ref?.current?.scrollWidth || 0;
    const dynamicHeight = calcDynamicHeight(objectWidth);
    setDynamicHeight(dynamicHeight);
  };

  const handleScrollTranslate = (ref, setTranslateX) => {    
    const offsetTop = ref?.current?.getBoundingClientRect();
    ref.current.style.transform = `translateX(${offsetTop.top}px)`;
    const offsetX = -offsetTop;
    setTranslateX(offsetX);
  };

const HorizontalScroll = ({ children }) => {
    const [dynamicHeight, setDynamicHeight] = useState(null);
    const [translateX, setTranslateX] = useState(0);

    const objectRef = useRef(null);
    const containerRef = useRef(null);
 
    useEffect(() => {
        const resizeHandler = () => {
            handleDynamicHeight(objectRef, setDynamicHeight);
        }

        const translateHandler = () => {
            handleScrollTranslate(containerRef, setTranslateX);
        }

        handleDynamicHeight(objectRef, setDynamicHeight);
        window.addEventListener('resize', resizeHandler);
        
        handleScrollTranslate(containerRef, setTranslateX);
        window.addEventListener("scroll", translateHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
            window.removeEventListener('scroll', translateHandler);
        }

    }, []);

    return (
        <TallOuterContainer height={dynamicHeight}>
            {/* <Parallax pages={2} style={{ top: '0', left: '0' }}>
                <ParallaxLayer offset={0} speed={1} style={{ backgroundColor: '#f0f0f0' }} />
                <ParallaxLayer offset={1} speed={1} style={{ backgroundColor: '#f0f0f0' }} />
            </Parallax> */}
         </TallOuterContainer>
   );
}

export default HorizontalScroll;